module.exports = __webpack_public_path__ + "static/dop-fe1da32be7112b11cf9374f61c8932d8.webp";